<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img
            class="img-fluid mx-auto d-block"
            src="@/assets/logo-indecx.png"
            alt=""
          />
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <font-awesome-icon :icon="['fas', 'user']" />
              </b-input-group-text>
              <b-input
                id="email"
                v-model="form.email"
                type="email"
                required
                :placeholder="$t('login.form.emailInput')"
                autofocus
              ></b-input>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <font-awesome-icon :icon="['fas', 'key']" />
              </b-input-group-text>
              <b-input
                id="password"
                v-model="form.password"
                type="password"
                required
                :placeholder="$t('login.form.passwordInput')"
                @keyup.enter="validateData()"
                autofocus
                autocomplete="off"
              ></b-input>
            </b-input-group>
          </b-form-group>
          <b-form-group>
            <b-button
              type="button"
              @click="validateData()"
              class="btn-block"
              variant="primary"
              :disabled="loading"
              ><span v-if="!loading">{{ $t('login.form.submitButton') }}</span>
              <b-spinner
                v-if="loading"
                small
                variant=""
                type="grow"
                label="Spinning"
                class="bg-"
              ></b-spinner>
            </b-button>
          </b-form-group>
          <router-link class="forgotPassword" to="/forgot-password">{{
            $t('login.form.forgotPasswordLabel')
          }}</router-link>
        </b-form>
        <div class="flag-align">
          <dropdownLanguage :isLogin="true" />
        </div>

        <div class="version">
          <p>V 2.9.31</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import dropdownLanguage from '../../../molecules/dropdown-country';
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';
import backgroundImage1_ from '../../../../assets/_1.png';
import backgroundImage2_ from '../../../../assets/_2.png';
import backgroundImage3_ from '../../../../assets/_3.png';
import backgroundImage4_ from '../../../../assets/_4.png';
import backgroundImage5_ from '../../../../assets/_5.png';
import backgroundImage6_ from '../../../../assets/_6.png';
import backgroundImage7_ from '../../../../assets/_7.png';
import api from '../../../../services/api';

// get initialStates
import settings from '../../../../store/modules/settings/initialState';
import auth from '../../../../store/modules/auth/initialState';
import actions from '../../../../store/modules/actions/initialState';
import treatments from '../../../../store/modules/treatments/initialState';
import templates from '../../../../store/modules/templates/initialState';
import alertRules from '../../../../store/modules/settings/alert-rules/initialState';
import research from '../../../../store/modules/research/initialState';
import companies from '../../../../store/modules/companies/initialState';
import charts from '../../../../store/modules/charts/initialState';
import master from '../../../../store/modules/master/initialState';
import trash from '../../../../store/modules/trash/initialState';
import answers from '../../../../store/modules/answers/initialState';
import clients from '../../../../store/modules/clients/initialState';
import submit from '../../../../store/modules/submit/initialState';
import panels from '../../../../store/modules/panels/initialState';

export default {
  name: 'Login',
  components: {
    dropdownLanguage,
  },
  data: () => ({
    show: true,
    loading: false,
    form: {
      email: null,
      password: null,
    },
    selectedCompany: null,
    companyOptions: [],
    companyList: [],
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
    states: {
      settings: Object.assign({}, settings),
      auth: Object.assign({}, auth),
      actions: Object.assign({}, actions),
      treatments: Object.assign({}, treatments),
      templates: Object.assign({}, templates),
      alertRules: Object.assign({}, alertRules),
      research: Object.assign({}, research),
      companies: Object.assign({}, companies),
      charts: Object.assign({}, charts),
      master: Object.assign({}, master),
      trash: Object.assign({}, trash),
      answers: Object.assign({}, answers),
      clients: Object.assign({}, clients),
      submit: Object.assign({}, submit),
      panels: Object.assign({}, panels),
      branches: {
        ih1: {
          listFilters: [],
          branches: [],
          total: 0,
          selected: [],
          all: false,
        },
        ih2: {
          listFilters: [],
          branches: [],
          total: 0,
          selected: [],
          all: false,
        },
        loading: false,
        createdBranches: [],
        createdBranchesIh2: [],
        myIh1: '0',
        myIh2: '0',
        myHierarchies1: [],
        myHierarchies2: [],
      },
      invites: {
        myInvites: {
          customers: [],
          paginate: 0,
          total: 0,
        },
        actionInfo: {},
        loadingModal: true,
        error: null,
      },
      closetheloop: { step: 1, submitDone: false },
      indicators: {
        actionIndicators: [],
        indicatorName: null,
        indicatorData: {
          key: null,
          value: null,
          period: null,
          range: {
            start: null,
            end: null,
            selected: null,
          },
        },
      },
      users: { user_data: {} },
      bulletins: {
        dailyEmails: [],
        weeklyEmails: [],
        monthlyEmails: [],
        annuallyEmails: [],
      },
      dashboard: {
        nps: null,
        percentilNps: {
          promoters: 0,
          passive: 0,
          detractors: 0,
        },
        grades: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
          4: 0,
          5: 0,
          6: 0,
          7: 0,
          8: 0,
          9: 0,
          10: 0,
        },
        answersByPhone: {},
        answersByEmail: {},
        answersByManual: {},
        answersByLinkWppWppWidgetQrCode: {},
        amountAnswers: 0,
        amountClients: 0,
        amountInvites: -1,
      },
      profiles: {
        allPermissions: [],
        profiles: [],
        nameProfile: null,
        permissions: {
          Ações: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Detalhes',
              value: false,
            },
            {
              name: 'Editar Ação',
              value: false,
            },
            {
              name: 'Enviar (disparo)',
              value: false,
            },
            {
              name: 'Excluir Ação',
              value: false,
            },
            {
              name: 'Criar Ação',
              value: false,
            },
          ],
          Respostas: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Editar Comentário',
              value: false,
            },
            {
              name: 'Excluir Resposta',
              value: false,
            },
            {
              name: 'Modo categorização',
              value: false,
            },
          ],
          Manual: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Registrar Resposta',
              value: false,
            },
          ],
          Disparos: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Visualizar Reenvio',
              value: false,
            },
            {
              name: 'Executar reenvio',
              value: false,
            },
            {
              name: 'Visualizar Lembretes',
              value: false,
            },
            {
              name: 'Cancelar Lembretes',
              value: false,
            },
            {
              name: 'Visualizar Agendimentos',
              value: false,
            },
            {
              name: 'Cancelar Agendimentos',
              value: false,
            },
          ],
          Tratativas: [
            {
              name: 'Cancelar Lembretes',
              value: false,
            },
            {
              name: 'Detalhes',
              value: false,
            },
            {
              name: 'Categorizar Resposta',
              value: false,
            },
            {
              name: 'Alterar Status',
              value: false,
            },
            {
              name: 'Alterar Status Encerrado',
              value: false,
            },
            {
              name: 'Tratativa em Massa',
              value: false,
            },
            {
              name: 'Responder por email',
              value: false,
            },
            {
              name: 'Categorizar tratativa',
              value: false,
            },
            {
              name: 'Habilitar comentário',
              value: false,
            },
          ],
          Relatórios: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Power BI',
              value: false,
            },
            {
              name: 'Análise IA',
              value: false,
            },
          ],
          Lixeira: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Restaurar Resposta',
              value: false,
            },
            {
              name: 'Restaurar Ação',
              value: false,
            },
          ],
          Dashboard: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
          ],
          Clientes: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Editar dados',
              value: false,
            },
          ],
          'Grupo de Ações': [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Associação de Ações',
              value: false,
            },
          ],
          Configurações: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
          ],
          Arquivos: [
            {
              name: 'Downloads',
              value: false,
            },
            {
              name: 'Uploads',
              value: false,
            },
          ],
          Painéis: [
            {
              name: 'Visualizar Menu',
              value: false,
            },
            {
              name: 'Compartilhar Painéis',
              value: false,
            },
            {
              name: 'Criar Painéis',
              value: false,
            },
            {
              name: 'Editar Painéis',
              value: false,
            },
            {
              name: 'Excluir Painéis',
              value: false,
            },
          ],
        },
        profileType: null,
        profileId: null,
      },
    },
  }),
  computed: {
    ...mapState('authentication', ['user']),
    ...mapState('settings', ['country']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['company']),
  },
  methods: {
    ...mapActions('authentication', ['login', 'logout']),
    ...mapActions('companies', ['getCompany']),

    setInitialStates() {
      // reset vuex initialStates
      Object.keys(this.states).forEach((key) => {
        this.$store.state[key] = this.states[key];
      });
    },

    getV3() {
      const userAuth = JSON.parse(localStorage.getItem('_indecx'));
      const { token } = userAuth;
      const host = window.location.host;
      const isStaging = host.includes('indecx.pe');
      const isLocalhost = host === 'localhost:8080' || host === 'localhost';
      // eslint-disable-next-line no-nested-ternary
      const url = isLocalhost
        ? `http://localhost:8080/redirect/${token}`
        : isStaging
          ? `https://stg.app-indecx.com/redirect/${token}`
          : `https://v3.app-indecx.com/redirect/${token}`;
      window.location.href = url;
    },

    validateData() {
      if (!this.loading) {
        this.loading = true;

        if (!this.form.email) {
          this.makeToast(
            this.$t('login.tooltips.emailValidation.description'),
            this.$t('login.tooltips.emailValidation.title'),
          );
        }

        if (!this.form.password) {
          this.makeToast(
            this.$t('login.tooltips.passwordValidation.description'),
            this.$t('login.tooltips.passwordValidation.title'),
          );
        }

        this.login({
          email: this.form.email,
          password: this.form.password,
          country: this.country,
          selectedCompany: this.selectedCompany,
        })
          .then(async (res) => {
            this.setInitialStates();

            this.companyList = res.companyList ? res.companyList : [];
            this.companyOptions = [];
            if (this.companyList && this.companyList.length > 1) {
              for (let i = 0; i < this.companyList.length; i += 1) {
                this.companyOptions.push({
                  text: this.companyList[i].companyName,
                  value: this.companyList[i].companyId,
                });
              }
            }

            if (!res.auth) {
              this.makeToast(
                this.$t('login.tooltips.loginValidation.description'),
                this.$t('login.tooltips.loginValidation.title'),
              );
            } else {
              await this.getCompany({
                id: res.companyId,
                token: res.token,
              });

              const emailDomain = this.user.email.split('@')[1];
              const isIndeCXMail = emailDomain === 'indecx.com.br';
              const isIndeCXCompany =
                this.company._id === '5d8ba15696fa442270173557';

              if (this.company.SSO) {
                  if(isIndeCXCompany || (!isIndeCXMail && !isIndeCXCompany)) {
                    this.$bvToast.toast(
                      'Esta organização utiliza autenticação via SSO. Por favor verifique o endereço correto para login',
                      {
                        title: 'Atenção',
                        autoHideDelay: 10000,
                        appendToast: false,
                        variant: 'danger',
                      },
                    );
                    this.logout(res.token);
                    this.loading = false;
                    return;
                  }
              }

              // verify enable two factor
              const enableTwoFactor = this.company.enableTwoFactor;
              // show tooltip "Testar nova versão"
              localStorage.setItem('testVersionTooltip', 'true');
              if (this.company.alertPopup) {
                localStorage.setItem('alertPopup', 'true');
              }
              if (enableTwoFactor) {
                // generate two factor code
                await api.post('/two-factor', {
                  email: this.user.email,
                });

                this.loading = false;

                this.$router.push({
                  name: 'Two Factor',
                  params: { email: this.user.email, companyId: res.companyId },
                });
              } else {
                this.loading = false;
                const returnUrl = localStorage.getItem('returnUrl');

                if (res.typeUser === 'admin-access') {
                  if(this.company.forceV3) {
                    this.getV3();
                  } else {
                    this.$router.push(`/profile-admin-access`);
                  }
                } else {
                  if (this.companyList.length > 1) {
                    this.$router.push(`/list-companies/${this.user._id}`);
                    return;
                  } else if (returnUrl && returnUrl !== 'undefined') {
                    this.$router.push(returnUrl);
                    localStorage.removeItem('returnUrl');
                    return;
                  } else if (this.company.homePageIsNotDashboard) {
                    if(this.company.forceV3) {
                      this.getV3();
                    } else {
                      this.$router.push(`/powerbi`);
                      return;
                    }
                  // eslint-disable-next-line no-else-return
                  } else {
                    this.$router.push(`/dashboard/${res.companyId}`);
                  }

                  if (
                    !this.user.permissions.permissions.dashboard.menu &&
                    this.companyList.length <= 1
                  ) {
                    if(this.company.forceV3) {
                      this.getV3();
                    } else {
                      this.$router.push(`/answers`);
                      return;
                    }
                  } else if(this.user.permissions.permissions.dashboard.menu) {
                    if(this.company.forceV3) {
                      this.getV3();
                    } else {
                      this.$router.push(`/dashboard/${res.companyId}`);
                      return;
                    }
                  }
                }
                if (this.company.favoritePeriod) {
                  this.calendarDates.selected = this.company.favoritePeriod;
                } else {
                  this.calendarDates.selected = 'Últimos 30 dias';
                }
              }
            }
            // else if (!res.hasStrongPassword) {
            //   this.$router.push(
            //     `/change-password?email=${btoa(this.form.email)}`,
            //   );
            // }
            this.loading = false;
          })
          .catch((err) => {
            const code = parseInt(err.message.replace(/[^0-9]/g, ''), 10);

            this.loading = false;

            switch (code) {
              case 400:
                this.makeToast(
                  this.$t('login.tooltips.loginValidation.description'),
                  this.$t('login.tooltips.loginValidation.title'),
                );
                break;
              case 401:
                this.makeToast(
                  this.$t('login.tooltips.loginValidation.description'),
                  this.$t('login.tooltips.loginValidation.title'),
                );
                break;
              case 403:
                this.makeToast(
                  this.$t('login.tooltips.loginNotAllowed.description'),
                  this.$t('login.tooltips.loginNotAllowed.title'),
                );
                break;
              case 406:
                this.makeToast(
                  this.$t('login.tooltips.blockByIncorrectLogin.description'),
                  this.$t('login.tooltips.blockByIncorrectLogin.title'),
                );
                break;
              default:
                this.makeToast(
                  this.$t('login.tooltips.genericError.description'),
                  this.$t('login.tooltips.genericError.title'),
                );
            }
          });
      }
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;

      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: 'danger',
      });
    },
  },
  created() {
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];

    const imgsIndecxAward = [
      backgroundImage1_,
      backgroundImage2_,
      backgroundImage3_,
      backgroundImage4_,
      backgroundImage5_,
      backgroundImage6_,
      backgroundImage7_,
    ];

    this.bgPage.background = `url('${
      imgsIndecxAward[Math.floor(Math.random() * imgsIndecxAward.length)]
    }')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.forgotPassword {
  display: block;
  text-align: center;
}

.wrapper {
  @extend %center;
  .bg-page {
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    // opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }

  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }

  .panel {
    width: 90%;
    max-width: 420px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));
    @media screen and (min-width: 576px) {
      width: 100%;
    }

    .body-panel-login {
      // @include bg-color($white);
      @extend %double-padding-left,
        %double-padding-right,
        %double-padding-top,
        %double-padding-bottom;

      form {
        @extend %double-padding-top, %double-padding-bottom;
        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }
        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }
        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }
      button {
        border-radius: 30px;
      }
    }
  }
}

.flag-align {
  position: absolute;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

.version {
  text-align: center;
  font-size: 12px;
  padding: 0px;
  margin-top: 30px;
  color: #4e4e4e;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/login/index.vue